import { Select,Form, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import {  useShangpinguigeListQuery, useShangpinListQuery } from '../../store/dianshangtaizhangApi';

function GoodsSpecSelect(props) {
    const [type,setType] = useState();
    const {data:dataType, isSuccess:isSuccessType} = useShangpinListQuery();
    useEffect(() => {
        if(isSuccessType){
            if(dataType.Status==='success'){
                console.log(dataType);
                const newArr = dataType.Result.map((item) => {
                    const {sp_id,sp_name,sp_hyt_id,sp_hyt_name,sp_qyt_id,sp_qyt_name}=item;
                    return item = {value:sp_id,label:sp_name,sp_hyt_id,sp_hyt_name,sp_qyt_id,sp_qyt_name }
                })
                setType(newArr)
            }
        }
    },[dataType,isSuccessType])
    const [typeId,setTypeId] = useState()
    const [list,setList] = useState();
    const {data, isSuccess} = useShangpinguigeListQuery({
        spgg_sp_id:typeId
    },{
        refetchOnMountOrArgChange:1,
        skip:!typeId,
    });
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {spgg_id,spgg_name,spgg_price,spgg_day}=item;
                    return item = {value:spgg_id,label:spgg_name,spgg_price,spgg_day}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            {props.direction==='vertical'?<>
                                                <Form.Item label='商品' name={props.nameOne}  required>
                                                    <Select 
                                                        options={type} 
                                                        onChange={(e,f) => {
                                                            console.log(e,f);
                                                            setTypeId(e);
                                                            props.onChangeOne(f.value,f.label,f.sp_hyt_id,f.sp_hyt_name,f.sp_qyt_id,f.sp_qyt_name)
                                                        }}
                                                        style={{width:"300px"}}
                                                    />
                                                </Form.Item>
                                                <Form.Item label='商品规格' name={props.nameTwo} required>
                                                    <Select 
                                                        options={list} 
                                                        onChange={(_,f) => {
                                                            // console.log(f);
                                                            props.onChangeTwo(f.value,f.label,f.spgg_price,f.spgg_day)
                                                        }}
                                                        placeholder={props.defaultId}
                                                        style={{width:"300px"}}
                                                    />
                                                </Form.Item>
                                            </>:<Form.Item 
                                                label={props.label} 
                                                required={props.required}       
                                            >
                                                <Space>
                                                    <Form.Item noStyle name={props.nameOne}>
                                                        <Select 
                                                            options={type} 
                                                            onChange={(e,f) => {
                                                                console.log(e,f);
                                                                setTypeId(e);
                                                                props.onChangeOne(f.value,f.label,f.sp_hyt_id,f.sp_hyt_name,f.sp_qyt_id,f.sp_qyt_name)
                                                            }}
                                                            style={{width:"300px"}}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item noStyle name={props.nameTwo}>
                                                        <Select 
                                                            options={list} 
                                                            onChange={(_,f) => {
                                                                // console.log(f);
                                                                props.onChangeTwo(f.value,f.label,f.spgg_price,f.spgg_day)
                                                            }}
                                                            placeholder={props.defaultId}
                                                            style={{width:"300px"}}
                                                        />
                                                    </Form.Item>
                                                </Space>
                                            </Form.Item>}
        </>
    )
}

export default GoodsSpecSelect